"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@mui/material/styles");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _react = _interopRequireDefault(require("react"));
var _Bps = _interopRequireDefault(require("./Bps.json"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * `useMediaQuery()` HOC wrapper
 * 
 * Makes an `isMobile` prop available on components.
 * 
 * @package HOPS
 * @subpackage Hoc
 * @author Carl Booth
 * @copyright Heritage Operations Processing Limited
 */const withMobile = Component => props => {
  const theme = (0, _styles.useTheme)();

  /**
   * Get the current Material UI breakpoint name.
   * @returns {string}
   */
  const useWidth = theme => {
    const keys = [...theme.breakpoints.keys].reverse();
    return keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = (0, _useMediaQuery.default)(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || "xs";
  };
  const isMobile = (0, _useMediaQuery.default)(theme.breakpoints.down("md"));
  const width = useWidth(theme);

  /**
   * Get whether we're at or above a given Material UI breakpoint name.
   * @param {string} breakpoint 
   * @returns {bool}
   */
  const atBreakpoint = breakpoint => {
    return _Bps.default.indexOf(width) >= _Bps.default.indexOf(breakpoint);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
    ...props,
    bp: atBreakpoint,
    isMobile: isMobile,
    width: width
  });
};
var _default = exports.default = withMobile;